import { ReactNode } from 'react'
import { QueryParamsProvider } from 'recruiter/contexts'

/**
 * A stack of any providers that should be made available to the entire
 * recruiter portal and rely on other, higher level providers such as the
 * router.
 */
export function RecruiterPortalProviders({
    children,
}: {
    children: ReactNode
}) {
    return <QueryParamsProvider>{children}</QueryParamsProvider>
}
